import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {UserService} from "auth-module/services/user.service";
import {environment} from "../../../../../environments/environment";
import {NodeType} from "../../../../shared/model/treeelement";
import {map} from "rxjs/operators";
import {ReportService} from "../../../../shared/services/report.service";

export interface OwnerElementDictionary {
  [key: string]: OwnerElement[];
}

export interface OwnerElement {
  label: string;
  id: number;
  extraData: {
    hasChildren: boolean;
    sameOwner: boolean;
  };
  type: NodeType;
  pos: number;
  path: string;
  parent: number;
  parentPage: number;
  owner?: string;
}

export interface TableDataSourceElement extends OwnerElement {
  ownerRowSpan?: number;
}

@Injectable({
  providedIn: 'root',
})
export class OwnerLoaderService {
  private httpService = inject(HttpClient);
  private userService = inject(UserService);
  private reportService = inject(ReportService);

  readonly compareFn = (a, b) => (a?.label || '').localeCompare(b?.label || '', undefined, {numeric: true});

  readonly ownerUrl = environment.api + this.userService.domain + '/owners';
  loadOwners = () => this.httpService
    .get<OwnerElementDictionary>(this.ownerUrl).pipe(map(result => {
      const dataSource: TableDataSourceElement[] = [];
      Object.keys(result).sort().forEach(key => {
        const searchElements = this.reportService.translateBackupElement(result[key].sort(this.compareFn));
        let ownerRowSpan = searchElements.length;
        searchElements.forEach((element) => {
          dataSource.push({
            ...element,
            owner: key,
            ownerRowSpan,
          })
          ownerRowSpan = 0;
        })
      });
      return dataSource;
    }));

  loadChildren = (parent: OwnerElement) => this.httpService.get<OwnerElement[]>(`${this.ownerUrl}/${parent.id}`, {
    params: {
      expectedOwner: parent.owner
    }
  }).pipe(
    map(result => this.reportService.translateBackupElement(
        result.sort((a, b) => a.pos - b.pos)
      ).map(searchElement => ({
        ...searchElement,
        owner: parent.owner
      }))
    )
  );
}
